import { useSelector } from 'react-redux';

// Offices are fetched on app initialization, so just process them here
const useOfficeOptions = municipality => {
  const offices = useSelector(state => state.reducer.offices);

  const filteredOffices = municipality
    ? offices?.filter(office => office.municipalityCode === municipality.value)
    : offices;

  const officeOptions = filteredOffices?.map(office => ({
    value: office.id,
    label: office.name,
    // Extras
    municipalityCode: office.municipalityCode,
    municipalityName: office.municipalityName,
  }));

  return officeOptions;
};

export default useOfficeOptions;
